export default __webpack_public_path__ + "static/media/Dinosaurs_12.e1225b43.png";